/* ==========================================================================
   OTOZIP GADING SERPONG LANDING PAGE SCRIPTS
   Scoped Wrapper: .oz-gading-serpong-page
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.oz-gading-serpong-page');
  if (!container) return;

  // 1. Single open accordion behavior for FAQs
  const faqItems = container.querySelectorAll('.oz-gading-serpong-faq-item');
  faqItems.forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (this.open) {
        faqItems.forEach(function(other) {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      }
    });
  });

  // 2. SEO Collapse Toggle Button Text
  const seoCollapse = container.querySelector('.oz-gading-serpong-seo-collapse');
  if (seoCollapse) {
    const seoBtn = seoCollapse.querySelector('.oz-gading-serpong-seo-btn');
    if (seoBtn) {
      seoCollapse.addEventListener('toggle', function() {
        if (this.open) {
          seoBtn.innerHTML = 'Sembunyikan &uarr;';
        } else {
          seoBtn.innerHTML = 'Lihat Selengkapnya &darr;';
        }
      });
    }
  }

  // 3. Smooth scroll for anchor links
  const internalLinks = container.querySelectorAll('a[href^="#"]');
  internalLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElement = container.querySelector(targetId) || document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});
